import { Badge, Box, Flex, IconButton, Text } from "@radix-ui/themes";
import React from "react";
import { useTranslation } from "react-i18next";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const ReportTreatmentStep = ({ icon, title, step, stepColor, redirect,onClick }) => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  const handleStepClick = () => {
    if (onClick) {
      onClick();
    } else  if (redirect) {
      navigate(redirect);
    }
  }


  return (
    <Box
      className="text-white rounded-xl h-56 p-6 border-2 border-solid border-gray-700"
      style={{
        backgroundColor: "rgb(43, 34, 56)",
        boxSizing: "border-box",
        width: "100%",
      }}
      onClick={handleStepClick}
    >
      <Flex
        direction="column"
        justify="space-between"
        align="stretch"
        style={{ height: "100%" }}
      >
        {/* Header Section */}
        <Flex justify="between" align="center">
          <Flex align="center" gap="2">
            <Box
              p="2"
              className="rounded-lg"
              style={{ backgroundColor: stepColor, boxSizing: "border-box" }}
            >
              {icon}
            </Box>
            <Text className="font-semibold">{title}</Text>
          </Flex>
          <Badge
            className="px-2 py-1 text-white text-xs rounded-xl"
            style={{ backgroundColor: stepColor }}
          >
             {`${t("step")} ${step}`}
          </Badge>
        </Flex>

        {/* Add Button Section */}
        <Flex justify="center" align="center" className="mt-auto mb-auto">
          <IconButton
            variant="ghost"
            size="3"
            radius="full"
            className="border-2 border-dashed hover:bg-transparent focus:bg-transparent active:bg-transparent cursor-pointer"
            style={{ borderColor: stepColor }}
          >
            <FaPlus className="w-6 h-6" style={{ fill: stepColor }} />
          </IconButton>
        </Flex>
      </Flex>
    </Box>
  );
};

export default ReportTreatmentStep;
